export const routes = {
	home: "/",
	productSearch: "/product-search",
	comparisons: "/comparisons",
	dataPipeline: "/instructions",
	howItWorks: "/how-it-works",
};
